<template>
    <tr>
        <td>{{index}}</td>
        <td>{{item.type}}</td>
        <td>{{item.id}}</td>
        <td>{{$utils.getFormatName(item.formats)}}</td>
        <td>{{item.quantity}}</td>
        <td>{{price.toFixed(2)}} €</td>
        <td>{{(price * item.quantity).toFixed(2)}} €</td>
        <td>{{item.layout ? item.layout.id : $t('COMMON.none')}}</td>
        <td>{{item.surface}}</td>
        <td>{{item.printed}}</td>
        <td>{{item.renderFinished}}</td>
        <td  class="text-danger" v-if="hasError">{{$t('COMMON.error')}}</td>
        <td  class="text-primary" v-else>{{$t('COMMON.good')}}</td>
    </tr>
</template>
<script>
import AnalyticsService from '../../Analytics/AnalyticsService';
import Filters from '../../../../mixins/CphFilters.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'OrderTableItem',
    mixins: [Filters, AnalyticsService],
    props: {
        item: {
            type: Object
        },
        index: {
            type: Number
        },
        price: {
            type: [Number, String]
        }
    },
    computed: {
        ...mapGetters({products : 'getProducts'}),
        hasError () {
            return this.products.findIndex(product => product.id === this.item.id) === -1;
        }
    }
};
</script>
